import onsiteNotification from './onsite-notification';

// Translate from HAL API to local data structure
function fromJSON(json: any) {
    if (!json) {
        return null;
    }

    return json._embedded.notifications.map(onsiteNotification.fromJSON);
}

export default { fromJSON };
